import { pedagogico } from "@/constants/pedagogico";
import { secretaria_financeiro } from "@/constants/secretaria_financeiro";

function getLabel(setor, servico, label) {
  const servicos = setor === "pedagogico" ? pedagogico : secretaria_financeiro;
  const data = servicos?.find((element) => element.id === servico);
  const options =
    data?.view?.options?.find((item) => item.id === label) ??
    [...pedagogico, ...secretaria_financeiro]
      .flatMap((s) => s.view?.options ?? [])
      .find((item) => item.id === label);
  return options?.label || label || "Não identificado";
}

export default getLabel;
